export default __webpack_public_path__ + "static/media/fa-icon-28-dark.d33eafc4.svg";